import './App.scss';
import { ThemeProvider } from 'react-jss';
import Theme from './components/sidebar/resources/theme';
import CustomerDashboard from './components/sidebar/index'
function App(props) {
    return (
        <ThemeProvider theme={Theme}>
            <CustomerDashboard/>
        </ThemeProvider>
    );
}
export default App;